// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "body {\n  background-color: #f5f6fa; }\n\n.card {\n  box-shadow: 0 0 10px rgba(28, 39, 60, 0.05); }\n", "",{"version":3,"sources":["skin.light.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB,EAAE;;AAE7B;EACE,2CAA2C,EAAE","file":"skin.light.css","sourcesContent":["body {\n  background-color: #f5f6fa; }\n\n.card {\n  box-shadow: 0 0 10px rgba(28, 39, 60, 0.05); }\n"]}]);
// Exports
module.exports = exports;
